'use strict';

exports.__esModule = true;
exports.default = {
  LIGHT: 'light',
  DARK: 'dark'
};
//# sourceMappingURL=ColorScheme.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-facebook/lib/constants/ColorScheme.js
// module id = 362
// module chunks = 0